<template>
  <div class="video-modal-content">
    <a-modal
      class="video-modal"
      v-model="visible"
      @cancel="handleCancel"
      :footer="null"
    >
      <video-embed
        :src="url"
        sandbox="allow-scripts allow-same-origin allow-presentation"
      ></video-embed>
    </a-modal>
  </div>
</template>
<script>
export default {
  name: "VideoModal",
  props: ["visible", "url"],
  methods: {
    handleCancel() {
      this.$emit("onModalClose");
    }
  }
};
</script>
<style lang="scss">
.video-modal {
  .ant-modal-close {
    top: -25px;
    right: -27px;
    background: #ffffff;
    border-radius: 50%;
  }
  .ant-modal {
    width: 90% !important;
    max-width: 800px;
    margin: 0 auto;
  }
}
</style>
